var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.892255,0,0,0.892255,-8.53916,94.7802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ultralight-S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.494,-35.352C89.844,-35.352 96.289,-42.578 96.289,-51.904C96.289,-60.693 89.697,-68.066 81.494,-68.066C73.242,-68.066 66.553,-60.645 66.65,-51.904C66.65,-42.578 73.096,-35.352 81.494,-35.352ZM37.256,-34.522C44.531,-34.522 50.147,-40.772 50.147,-48.926C50.147,-56.543 44.434,-62.988 37.256,-62.988C30.078,-62.988 24.268,-56.543 24.365,-48.926C24.365,-40.772 29.932,-34.522 37.256,-34.522ZM125.391,-34.522C132.666,-34.522 138.232,-40.772 138.232,-48.926C138.232,-56.543 132.568,-62.988 125.391,-62.988C118.213,-62.988 112.451,-56.543 112.451,-48.926C112.451,-40.772 118.066,-34.522 125.391,-34.522ZM14.648,-0.928L48.291,-0.928C44.092,-3.418 46.875,-14.99 55.469,-22.363C51.27,-25.977 45.313,-28.662 37.158,-28.662C20.117,-28.662 9.57,-16.504 9.57,-5.615C9.57,-2.246 11.377,-0.928 14.648,-0.928ZM147.949,-0.928C151.221,-0.928 153.027,-2.246 153.027,-5.615C153.027,-16.504 142.48,-28.662 125.488,-28.662C117.334,-28.662 111.377,-25.977 107.129,-22.363C115.723,-14.99 118.555,-3.418 114.307,-0.928L147.949,-0.928ZM55.518,-0.928L107.227,-0.928C110.986,-0.928 113.086,-2.051 113.086,-5.322C113.086,-15.039 100.928,-28.467 81.397,-28.467C61.816,-28.467 49.658,-15.039 49.658,-5.322C49.658,-2.051 51.758,-0.928 55.518,-0.928Z",
    style: {
      fill: "rgb(90,165,239)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewers);
export default __webpack_public_path__ + "static/media/viewers.b4e4a00f20527d892fb46e2049f41b62.svg";
export { ForwardRef as ReactComponent };